import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from '../HeaderControls/index.module.scss';

export const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const zh = i18n.language?.startsWith('zh');
  const label = zh ? 'Switch to English' : '切换到中文';

  const toggleLanguage = () => {
    const language = zh ? 'en' : 'zh';
    i18n.changeLanguage(language);
    dispatch({ type: 'global/setUiLanguage', payload: language });
  };

  return (
    <button type="button" className={styles.control} onClick={toggleLanguage} title={label} aria-label={label}>
      {zh ? '中文' : 'EN'}
    </button>
  );
};
